/** POST-UC-13: открытое в просмотре медиа поста записано в адресе страницы. */
export const VIEWER_QUERY = 'media';

export function viewerSearch(mediaId: string): string {
  return `?${VIEWER_QUERY}=${encodeURIComponent(mediaId)}`;
}

export interface ViewerPosition {
  /** Номер медиа в посте, с 1. */
  n: number;
  total: number;
  prev: string | undefined;
  next: string | undefined;
}

/** Место медиа среди медиа поста; null — медиа к посту не прикреплено (POST-UC-13.CC-1). */
export function viewerPosition(mediaIds: readonly string[], mediaId: string): ViewerPosition | null {
  const index = mediaIds.indexOf(mediaId);
  if (index === -1) return null;
  return { n: index + 1, total: mediaIds.length, prev: mediaIds[index - 1], next: mediaIds[index + 1] };
}
